




































































import { Component, Provide, Vue } from 'vue-property-decorator';
import DonorService from '../../services/donor-form.service.js';

@Component({
  props: ['organizationId'],
})
export default class ImportModal extends Vue {
  @Provide()
  isImportProcessed: boolean = false;
  isImportFail: boolean = false;
  type: number = 0;
  file: any = null;

  showModal() {
    this.isImportProcessed = false;
    this.isImportFail = false;
    this.$root.$emit('bv::show::modal', 'import-donors-modal');
  }

  hideModal() {
    this.$root.$emit('bv::hide::modal', 'import-donors-modal');
    this.$emit('closeModal');
  }

  importDonors() {
    DonorService.import(this);
  }
}
